"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAble = void 0;
var _react = _interopRequireDefault(require("react"));
var _ableSprites = _interopRequireDefault(require("@able/web/dist/symbol/able-sprites.svg"));
var _utility = require("../utility");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var IconAble = function IconAble(_ref) {
  var icon = _ref.icon,
    className = _ref.className,
    screenReaderContent = _ref.screenReaderContent;
  var customAttributes = {};
  if (screenReaderContent) {
    customAttributes = {
      'aria-label': screenReaderContent,
      'aria-hidden': false
    };
  }
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    className: (0, _utility.classNames)("able-icon tl-default-svg-class", className),
    role: "img",
    focusable: "false",
    "aria-hidden": true
  }, customAttributes), /*#__PURE__*/_react.default.createElement("use", {
    href: "".concat(_ableSprites.default, "?v20#").concat(icon)
  }));
};
exports.IconAble = IconAble;